<form [formGroup]="currentVSGroup">
    <div class="columns">
        <div class="column is-6" >
            <div class="parameters-box" formArrayName="blendersForm" >
                <div class="parameters-title-row">
                    <h2 class="parameters-title">Producción</h2>
                    <div class="bulk-col">
                        <label class="bulk-label" for="produccion-bulk-delay">Retraso (h)</label>
                        <input class="input bulk-input" id="produccion-bulk-delay" type="number"
                            [value]="blendersBulk.delay ?? ''"
                            (input)="onBlendersBulkInput('delay', $any($event.target).value)" />
                    </div>
                    <div class="bulk-col">
                        <label class="bulk-label" for="produccion-bulk-oee">OEE (%)</label>
                        <input class="input bulk-input" id="produccion-bulk-oee" type="number"
                            [value]="blendersBulk.oee ?? ''"
                            (input)="onBlendersBulkInput('oee', $any($event.target).value)" />
                    </div>
                </div>
                <div class="parameters-table">
                    <div class="header">
                        <h2 class="parameter">Blenders</h2>
                        <h2 class="parameter">Retraso (h)</h2>
                        <h2 class="parameter">OEE (%)</h2>
                    </div>
                    <div *ngFor="let control of blendersForm.controls; let i = index" [formGroupName]="i" [ngStyle]="{'background': (i % 2 === 0 ? 'rgb(246, 246, 246)': 'white')}">
                        <div *ngFor="let key of getFormGroupKeys(control)" [formGroupName]="key" class="item" >
                            <h3 class="key">{{ key }}</h3>
                            <input class="input" id="{{ key }}-delay" formControlName="delay" type="number" />
                            <input class="input" id="{{ key }}-oee" formControlName="oee" type="number" />
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div class="column is-6">
            <div class="parameters-box" formArrayName="packagingMachinesForm">
                <div class="parameters-title-row">
                    <h2 class="parameters-title">Envasado</h2>
                    <div class="bulk-col">
                        <label class="bulk-label" for="envasado-bulk-delay">Retraso (h)</label>
                        <input class="input bulk-input" id="envasado-bulk-delay" type="number"
                            [value]="packagingBulk.delay ?? ''"
                            (input)="onPackagingBulkInput('delay', $any($event.target).value)" />
                    </div>
                    <div class="bulk-col">
                        <label class="bulk-label" for="envasado-bulk-oee">OEE (%)</label>
                        <input class="input bulk-input" id="envasado-bulk-oee" type="number"
                            [value]="packagingBulk.oee ?? ''"
                            (input)="onPackagingBulkInput('oee', $any($event.target).value)" />
                    </div>
                </div>
                <div class="parameters-table">
                    <div class="header">
                        <h2 class="parameter">Envasadoras</h2>
                        <h2 class="parameter">Retraso (h)</h2>
                        <h2 class="parameter">OEE (%)</h2>
                    </div>
                    <div *ngFor="let control of packagingMachinesForm.controls; let i = index" [formGroupName]="i" [ngStyle]="{'background': (i % 2 === 0 ? 'rgb(246, 246, 246)': 'white')}">
                        <div *ngFor="let key of getFormGroupKeys(control)" [formGroupName]="key" class="item">
                            <h3 class="key">{{ key }}</h3>
                            <input class="input" id="{{ key }}-delay" formControlName="delay" type="number" />
                            <input class="input" id="{{ key }}-oee" formControlName="oee" type="number" />
                        </div>
                    </div>
                </div>
            </div>
            <div class="parameters-box" formArrayName="qualityForm" >
                <h2 class="parameters-title">Calidad</h2>
                <div class="parameters-table">
                    <div class="header">
                        <h2 class="parameter"></h2>
                        <h2 class="parameter">Retraso (h)</h2>
                        <h2 class="parameter">OEE (%)</h2>
                    </div>
                    <div *ngFor="let control of qualityForm.controls; let i = index" [formGroupName]="i" [ngStyle]="{'background': (i % 2 === 0 ? 'rgb(246, 246, 246)': 'white')}">
                        <div *ngFor="let key of getFormGroupKeys(control)" [formGroupName]="key" class="item">
                            <h3 class="key">{{ key }}</h3>
                            <input class="input" id="{{ key }}-delay" formControlName="delay" type="number" />
                            <input class="input" id="{{ key }}-oee" formControlName="oee" type="number" />
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</form>